import AppLoader from '@/app-loader'

export default {
  data: () => ({
    confirmTitle: '',
    confirmText: '',
    confirmYes: '',
    confirmNo: '',
    confirmTheme: '',
    confirmMaxWidth: '',
    show: false,
    boxGuid: null,
    zIndex: null,
    guid: null,
    authorizationKey: null,
    toolTipVisible: true,
    providerId: null
  }),
  computed: {
    getProviders () {
      return this.$store.getters.providers
    }
  },
  methods: {
    showDialog() {
      this.confirmTitle = this.getTranslation('disasterAuthorization.title')
      this.confirmText = this.getTranslation('disasterAuthorization.text')
      this.confirmYes = this.getTranslation('disasterAuthorization.save')
      this.confirmNo = this.getTranslation('disasterAuthorization.useReadOnly')
      this.confirmTheme = 'primary'
      this.confirmMaxWidth = '600'
      this.show = true
      this.zIndex = 3
    },
    onYes() {
      if (this.authorizationKey) {
        this.$emit('saved', this.authorizationKey)
        if (this.providerId) {
          this.$store.commit('providerId', this.providerId)
          this.show = false
        } else {
          this.showError(this.getTranslation('disasterAuthorization.insertAProvider'))
        }
      } else {
        this.showError(this.getTranslation('disasterAuthorization.insertAValidKey'))
      }
    },
    onNo() {
      this.show = false
      this.$emit('canceled', {
        response: 'no',
        guid: this.guid
      })
    },
    getTranslation(key) {
      return AppLoader.getInstance().$t(key)
    },
    openModal () {
      this.show = !this.show
      this.toolTipVisible = this.show
      this.showDialog()
    },
    closeModal () {
      this.show = !this.show
    }
  }
}
